import React from 'react';
import clsx from 'clsx';
import { SwipeableHandlers } from 'react-swipeable';
import { Slide } from '@material-ui/core';

import MediaPreviewStyles from './styles';

type Props = {
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const NoPreview = ({ swipeable, slideDirection, isChangePreviewMedia }: Props) => {
  const classes = MediaPreviewStyles();

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
    >
      <div {...swipeable} className={classes.wrapper}>
        <div>
          <p className={classes.title}>No preview available</p>
          <p className={clsx(classes.title, classes.text)}>
            We are still processing this file. Please check back in a few minutes to preview or download the file.
          </p>
        </div>
      </div>
    </Slide>
  );
};

export default NoPreview;
